require('./cardStatementMovements.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ utilities
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
// @ components
const CardStatementMovementsTableRow = require('components/cards/cardStatementMovements/cardStatementMovementsTableRow/cardStatementMovementsTableRow');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ commons
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKButton } = require('components/commons/OKButton/OKButton');
// constants
const { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } = require('constants/commonsComponents');
const language = getLanguage();

class CardStatementMovements extends React.Component {
    constructor(props) {
        super(props);

        this.handleSeeMoreClick = this.handleSeeMoreClick.bind(this);
    }

    buildEmptySate() {
        const primaryText = formatText('cardStatementMovements-noResults');
        return <EmptyState primaryText={primaryText} iconType="noitems-banking"/>;
    }

    buildTableHead() {
        const { immScreen } = this.props;

        let tableHead;

        if (!immScreen.get('isMobile')) {
            tableHead = (
                <thead>
                    <OKTableRow asHeader={true}>
                        <OKTableCell asHeader={true}>
                            <FormattedText value="cardStatementMovements-date" />
                        </OKTableCell>
                        <OKTableCell asHeader={true}>
                            <FormattedText value="cardStatementMovements-hour" />
                        </OKTableCell>
                        <OKTableCell asHeader={true}>
                            <FormattedText value="cardStatementMovements-description" />
                        </OKTableCell>
                        <OKTableCell asHeader={true}>
                            <FormattedText value="cardStatementMovements-cardNumber" />
                        </OKTableCell>
                        <OKTableCell className="text-right" asHeader={true}>
                            <FormattedText value="cardStatementMovements-import" />
                        </OKTableCell>
                    </OKTableRow>
                </thead>
            );
        }

        return tableHead;
    }

    buildMovementsTable(immMovements) {
        const tableHead = this.buildTableHead();

        return (
            <LastMovementsTable
                groupByDate={false}
                rowComponent={CardStatementMovementsTableRow}
                immTransactionsByOrder={immMovements.get('byOrder')}
                immTransactionsById={immMovements.get('byId')}
                columnsCount={5}
                id={'card-statement-movements'}
                currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                language={language}
            >
                {tableHead}
            </LastMovementsTable>
        );
    }

    buildSeeMoreSection() {
        const { immMovements } = this.props;
        let content;

        if (!!immMovements.get('nextPage')) {
            if (immMovements.get('isFetchingNextPage')) {
                content = <LoadingSection />;
            } else {
                content = (
                    <div className="card-statement-movements__see-more">
                        <OKButton
                            onClick={this.handleSeeMoreClick}
                            modifier="link-complementary"
                        >
                            <FormattedText value="cardStatementMovements-seeMore" />
                        </OKButton>
                    </div>
                );
            }
        }

        return content;
    }

    handleSeeMoreClick() {
        const { statementId, requestNextPage } = this.props;
        requestNextPage(statementId);
    }

    render () {
        const { immMovements } = this.props;
        const title = formatText('cardStatementMovements-title');
        const seeMoreSection = this.buildSeeMoreSection();
        let content;

        if (!immMovements || immMovements.get('isFetching')) {
            content = <LoadingSection />;
        } else if (immMovements.get('byOrder').size === 0) {
            content = this.buildEmptySate();
        } else {
            content = this.buildMovementsTable(immMovements);
        }

        return (
            <OKSectionBox title={title}>
                {content}
                {seeMoreSection}
            </OKSectionBox>
        );
    }
}

CardStatementMovements.propTypes = {
    immMovements: PropTypes.object,
    immScreen: PropTypes.object.isRequired,
    requestMovements: PropTypes.func,
    statementId: PropTypes.string.isRequired,
    requestNextPage: PropTypes.func.isRequired
};

module.exports = CardStatementMovements;
